import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { t } from 'src/tools/text.tools';
import { useForm } from 'src/hooks/useForm';

import { getIsLoading } from 'src/store/loading/loading.reducer';
import { loginUser } from 'src/store/user/user.actions';

import Form from 'src/components/Form';
import { Title } from 'src/components/Title';
import { ModalDialog } from 'src/components/ModalDialog';

import { LOG_IN_FORM_SCENARIO } from 'src/data/logIn.data';
import { PlainPrimaryButton } from 'src/components/Button';
import { PATHS } from 'src/data/routes.data';
import { Result } from 'src/models';
import { useNavigation } from 'src/hooks';

import classes from './Login.module.scss';

const TXT = t(['logIn']);

const TXT_FORM = t(['logIn', 'form']);

export default function LogIn() {
  const dispatch = useDispatch();

  const { form, setForm, isValid, errors } = useForm(LOG_IN_FORM_SCENARIO);

  const isLoading = useSelector(getIsLoading);

  const { go } = useNavigation();

  const isDisabled = !isValid || isLoading;

  function handleResults({ isOK }: Result) {
    if (isOK) go(PATHS.TWO_FACTOR_AUTHENTICATION);
  }

  function handleSubmit() {
    if (!isDisabled) dispatch(loginUser(form, { callback: handleResults }));
  }

  function renderForgotPasswordLink() {
    return <PlainPrimaryButton label={TXT_FORM(['buttons', 'forgotPassword'])} to={PATHS.FORGOT_PASSWORD} />;
  }

  return (
    <div className='page-with-modal'>
      <Title title={TXT('welcome')} />
      <ModalDialog
        title={TXT_FORM('title')}
        primaryButton={[TXT_FORM(['buttons', 'logIn']), handleSubmit, isDisabled]}
        bottomRightContent={renderForgotPasswordLink()}
        containerClassName={classes.container}
      >
        <Form
          setFormData={setForm}
          formData={form}
          scenario={LOG_IN_FORM_SCENARIO}
          errors={errors}
          actions={{ submit: handleSubmit }}
        />
      </ModalDialog>
    </div>
  );
}
